// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"43":"test","177":"home","343":"onboarding","757":"game"}[chunkId] + "." + {"43":"90cfbaa4","177":"4e876393","343":"d996cf04","757":"7dc665a1"}[chunkId] + ".css";
};